import { useParams } from "react-router-dom";

import { useGetConsultationExport } from "~/providers/hooks";
import { getFullName, PatientParams } from "~/providers/utils";
import { PdfDownloadLink } from "../shared/PdfDownloadLink";
import { ConsultationExportDocument } from "./ConsultationExportDocument";

export const ConsultationExportDownloadLink = () => {
  const { patientId } = useParams<keyof PatientParams>() as PatientParams;
  const { data, isLoading } = useGetConsultationExport({ patientId });

  if (isLoading || !data) return null;

  return (
    <PdfDownloadLink
      document={<ConsultationExportDocument data={data} />}
      fileName={`Consultation report - ${getFullName(
        data.patient.name,
        data.patient.last_name,
      )}.pdf`}
    />
  );
};
